<loading *ngIf="!error && !filteredData" class="full" title="">
  <ng-container i18n="@@brokerBalance.loading">Loading your portfolio</ng-container>
</loading>

<error *ngIf="error" class="full" title="">
  {{error}}
</error>

<div *ngIf="filteredData" class="content" title="">
  <scrollable [containerHeight]="containerHeight">
    <div class="site-list with-img no-last-border">
      <div class="list-item header">
        <div class="list-item-content row align-items-center">
          <div class="col-6 text-bold" i18n="@@brokerBalance.title">Portfolio</div>
          <div class="col-6 d-flex flex-column">
            <ng-container [ngSwitch]="promotion?.status">
              <ng-container *ngSwitchCase="PromotionStatus.ENABLED">
                <ng-container *ngIf="total?.amount; else noTotal">
                  <div class="text-end">
                    <div class="text-bold" i18n="@@brokerBalance.promotion.total.line1">{{total?.currency}} {{ total?.amount || 0 | number:'1.2-2' }}</div>
                    <div *ngIf="useGlobalCurrency && baseCurrencyTotal?.currency !== baseCurrencyTotal?.currency" class="text-black text-sm text-end">{{baseCurrencyTotal?.currency}} {{ baseCurrencyTotal?.amount | number:'1.2-2' }}</div>
                    <div class="text-xs" i18n="@@brokerBalance.promotion.total.line2">+ {{promotion?.reward?.currency}} {{promotion?.reward?.amount}} reward pending</div>
                  </div>
                </ng-container>
                <ng-template #noTotal>
                  <div class="text-end">
                    <div class="text-bold">{{promotion?.reward?.currency}} {{promotion?.reward?.amount}}</div>
                    <div class="text-xs" i18n="@@brokerBalance.promotion.noTotal.line2">complimentary reward</div>
                  </div>
                </ng-template>
              </ng-container>
              <ng-container *ngSwitchDefault="">
                <div class="text-bold text-end">{{total?.currency}} {{ total?.amount | number:'1.2-2' }}</div>
                <div *ngIf="useGlobalCurrency" class="text-black text-sm text-end">{{baseCurrencyTotal?.currency}} {{ baseCurrencyTotal?.amount | number:'1.2-2' }}</div>
              </ng-container>
            </ng-container>
          </div>

        </div>
      </div>
      <div *ngFor="let balance of filteredData" class="list-item">
        <div class="list-item-img">
          <currency [currency]="balance?.currency?.code"></currency>
        </div>
        <div class="list-item-content">
          <div class="row g-0 align-items-center">
            <div class="col-6" [ngSwitch]="title">
              <div *ngSwitchCase="TitleType.Code" class="title">{{balance?.currency?.code}}</div>
              <div *ngSwitchCase="TitleType.Name" class="title">
                <ng-container [ngSwitch]="balance?.currency?.name">
                  <ng-container *ngSwitchCase="BTC_WALLET" i18n="@@brokerBalance.multisig.name">Bitcoin Multisig.</ng-container>
                  <ng-container *ngSwitchDefault="">{{balance?.currency?.name}}</ng-container>
                </ng-container>
              </div>
              <div *ngSwitchDefault="" class="title">
                <ng-container [ngSwitch]="balance?.currency?.name">
                  <ng-container *ngSwitchCase="BTC_WALLET"><ng-container i18n="@@brokerBalance.multisig.name">Bitcoin Multisig.</ng-container> ({{balance?.currency?.code}})</ng-container>
                  <ng-container *ngSwitchDefault="">{{balance?.currency?.name}} ({{balance?.currency?.code}})</ng-container>
                </ng-container>
              </div>
              <div class="text text-sm text-black">
                {{(balance?.balance?.amount?.amount || 0) | number:'1.2-8'}} {{balance?.currency?.code}}
              </div>
            </div>
            <div class="col-6 text-end ">
              <ng-container [ngSwitch]="useGlobalCurrency">
                <ng-container *ngSwitchCase="true">
                  <div class="text">
                    {{balance?.balance?.usdValue?.currency || globalCurrency}} {{(balance?.balance?.usdValue?.amount || 0) | number:'1.2-8'}}
                  </div>
                  <div *ngIf="balance?.balance?.usdValue?.currency !== balance?.balance?.amount?.currency || defaultCurrency" class="text text-sm">
                    {{balance?.balance?.value?.currency}} {{balance?.balance?.value?.amount || 0 | number:'1.2-8'}}
                  </div>
                </ng-container>
                <div class="text" *ngSwitchCase="false">
                  {{balance?.balance?.value?.currency || defaultCurrency}} {{(balance?.balance?.value?.amount || 0) | number:'1.2-8'}}
                </div>   
              </ng-container>
            </div>
          </div>
        </div>
      </div><!-- .list-item -->
    </div><!-- .site-list -->
  </scrollable>
</div>


